import React from 'react';
import { Link } from 'react-router-dom';

function CitiesSection() {
  const cities = [
    { name: "New York City, NY", route: "/new-york-city" },
    { name: "Connecticut, CT", route: "/connecticut" },
    { name: "New Jersey, NJ", route: "/new-jersey" },
    { name: "Pennsylvania, PA", route: "/pennsylvania" },
    { name: "Washington, D.C", route: "/washington-dc" },
    { name: "Rhode Island, RI", route: "/rhode-island" }
  ];

  // Duplicate cities for seamless loop
  const duplicatedCities = [...cities, ...cities];

  return (
    <section className="bg-orange-200 py-4 overflow-hidden">
      <div className="relative">
        {/* Moving Cities Container */}
        <div className="flex animate-scroll">
          {duplicatedCities.map((city, index) => (
            <Link
              key={index}
              to={city.route}
              className="flex-shrink-0 text-gray-800 text-center py-2 px-8 hover:text-gray-600 transition-colors duration-300 min-w-[200px]"
            >
              <span className="text-sm md:text-base font-medium whitespace-nowrap">
                {city.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CitiesSection;
